import type { UnknownAction } from "redux";

import type { RequestCleanupCreateFormAction } from "../create/createFormActions";
import type { SetCreateResultAction } from "../create/createMetaActions";

export type MultiCreateActions =
  | ShowCreatePanelAction
  | HideCreatePanelAction
  | CreateClearTempResultAction
  | SetCreateResultAction
  | RequestCleanupCreateFormAction;

export interface CreateClearTempResultAction extends UnknownAction {
  payload: {};
  type: "MULTIPLE_CREATE:CLEAR_TEMP_RESULT";
}

export const clearTempCreateResult = (): CreateClearTempResultAction => ({
  payload: {},
  type: "MULTIPLE_CREATE:CLEAR_TEMP_RESULT",
});

export interface ShowCreatePanelAction extends UnknownAction {
  payload: {};
  type: "MULTIPLE_CREATE:SHOW";
}

export const showCreatePanel = (): ShowCreatePanelAction => ({
  payload: {},
  type: "MULTIPLE_CREATE:SHOW",
});

export interface HideCreatePanelAction extends UnknownAction {
  payload: {};
  type: "MULTIPLE_CREATE:HIDE";
}

export const hideCreatePanel = (): HideCreatePanelAction => ({
  payload: {},
  type: "MULTIPLE_CREATE:HIDE",
});
